import React from 'react';

export const labelStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: '0.5rem',
  fontWeight: 500,
  fontSize: 'clamp(11px, 1.6vw, 13px)',
  lineHeight: 1.2,
};

export const controlStyle: React.CSSProperties = {
  width: '100%',
  padding: '8px 10px',
  borderRadius: 10,
  border: '1px solid #E5E7EB',
  fontSize: 'clamp(11px, 1.5vw, 13px)',
  lineHeight: 1.2,
};

export const flexControlStyle: React.CSSProperties = {
  ...controlStyle,
  flex: 1,
};
